module.exports = __webpack_public_path__ + "img/lessonpre_next_left_normal.03f729f3.svg";